module.exports = __webpack_public_path__ + "img/tu01.1ed75128.jpg";